import {axiosInstanceWithToken}  from "../utils/Client";

export default class StaffDashboardService {
    static getStaffKPI = () => {
        return axiosInstanceWithToken.get(`/staff/compensation_kpi/`);
    };

    static getClockInOut = () => {
        return axiosInstanceWithToken.get(`/clock_in_out/`);
    };

    static getClockOutReasons = () => {
        return axiosInstanceWithToken.get(`/clock_out_reason/`);
    };

    static postClockIn = () => {
        return axiosInstanceWithToken.post(`/clock_in_out/`, {});
    };

    static putClockOut = (reason) => {
        return axiosInstanceWithToken.put(`/clock_in_out/`, reason);
    };

    static getScore = (all) => {
        return axiosInstanceWithToken.get(`/scores/?all=${all}`);
    };

    static getKPIHeadings = (kpiId) => {
        return axiosInstanceWithToken.get(`/achievement/heading/${kpiId}/`);
    };

    static postAchievement = (achievementData) => {
        return axiosInstanceWithToken.post(`/achievement/`, achievementData);
    };

    static getAchievementList = (
        kpiId, startDate, endDate, searchString, adminAchievementFilter, page=1
    ) => {
        if (typeof searchString === "undefined") {
            searchString = '';
        }
        adminAchievementFilter = Number(adminAchievementFilter);
        let url = `/achievement/${kpiId}/?search_string=${searchString}`
        url += `&admin_achievement=${adminAchievementFilter}&page=${page}`;

        if(typeof startDate !== "undefined" && startDate !== "Invalid date") {
            url += `&start_date=${startDate}`;
        }

        if(typeof endDate !== "undefined" && endDate !== "Invalid date") {
            url += `&end_date=${endDate}`;
        }

        return axiosInstanceWithToken.get(url);
    };

    static getKPIDetails = (kpiId) => {
        return axiosInstanceWithToken.get(`/kpi/details/${kpiId}/`);
    };

    static postRequestCorrection = (requestData) => {
        return axiosInstanceWithToken.post(`/correction/requests/`, requestData);
    };

    static getStaffCorrections = () => {
        return axiosInstanceWithToken.get(`/correction/requests/`);
    };

    static checkRecordInCorrectionList = (recordId) => {
        return axiosInstanceWithToken.get(`/correction/request/check/${recordId}`);
    };

    static getAchievementPDF = (
        kpiId, startDate, endDate, searchString, adminAchievementFilter
    ) => {
        if (typeof searchString === "undefined") {
            searchString = '';
        }
        adminAchievementFilter = Number(adminAchievementFilter);
        let url = `/staff/achievement/report/${kpiId}/?search_string=${searchString}`
        url += `&admin_achievement=${adminAchievementFilter}`;

        if(typeof startDate !== "undefined" && startDate !== "Invalid date") {
            url += `&start_date=${startDate}`;
        }

        if(typeof endDate !== "undefined" && endDate !== "Invalid date") {
            url += `&end_date=${endDate}`;
        }

        return axiosInstanceWithToken.get(url);
    };

    static getKPIExplanationPDF = () => {
        return axiosInstanceWithToken.get(`/kpi_explanation/report/`);
    };

    static getCompensationAgreementPDF = () => {
        return axiosInstanceWithToken.get(`/staff/compensation_agreement/report/`);
    };

    static getTimesheetPDF = () => {
        return axiosInstanceWithToken.get(`/staff/timesheet/report/`);
    };

    static getPerformanceEvaluationPDF = () => {
        return axiosInstanceWithToken.get(`/staff/performance/report/`);
    };

    static setPassword = (passwordDetail) => {
        return axiosInstanceWithToken.put(`/auth/reset_password/`, passwordDetail);
    };

    static getUserProfile = () => {
        return axiosInstanceWithToken.get(`/profile/`);
    };

    static setUserProfile = (profileDetail) => {
        return axiosInstanceWithToken.patch(`/profile/`, profileDetail);
    };

    //Function to generate audit form
    static getAuditFormReport = (compId, auditId='') => {
        return axiosInstanceWithToken.get(`/audit_form/report/${compId}/?audit_id=${auditId}`);
    };

    //Function to get departments all/location wise
    static getDepartmentList = (all) => {
        return axiosInstanceWithToken.get(`/staff/departments/?all=${all}`);
    };

    // get no of location in the agency of the logged-in user
    static getLocationCount = () => {
        return axiosInstanceWithToken.get(`/location/count/`);
    };

    // get list of compensation profile of the logged-in user
    static getStaffCompensationList = () => {
        return axiosInstanceWithToken.get(`/staff/compensation/list/`);
    };

    // get list of staff sales data of the logged-in user
    static getStaffRevenues = (compProfileId) => {
        return axiosInstanceWithToken.get(`/staff_revenue/list/${compProfileId}/`);
    };

    // update staff sales data of the logged-in user
    static updateStaffRevenues = (revenues) => {
        return axiosInstanceWithToken.put(`/staff_revenue/`, revenues);
    };

    // get total agency revenue
    static getAgencyTotalRevenues = (plProfileId) => {
        return axiosInstanceWithToken.get(`/revenue/actual/total/${plProfileId}/`);
    };

    // update seen status of staff dashboard video
    static updateDashboardVideoStatus = () => {
        return axiosInstanceWithToken.put(`/dashboard/video/status/`);
    };

    // get staff tarining video list
    static getFirstTimeVideo = () => {
        return axiosInstanceWithToken.get(`/knowledge_base/first_time/video/`);
    };

    // get staff tarining video list
    static getTrainingVideoList = () => {
        return axiosInstanceWithToken.get(`/knowledge_base/training/video/list/`);
    };
}


// WEBPACK FOOTER //
// ./src/services/StaffDasboardService.js